module.exports = __webpack_public_path__ + "img/logo.96dd6e29.png";